<template>
  <div style="margin-top:10px;">
    <Header :window="window" :parameters="'questionner'" />
    <div
      class="container"
      style="margin-top:10px;min-height:90vh; padding:10px;"
      :style="this.background"
    >
      <FormQuestionner
        :checkingUrlParticipant="this.loading"
        :meetingId="this.meeting_id"
        :urlParticipant="this.url_participant"
      />
    </div>
    <MyFooter :window="window" />
  </div>
</template>

<script>
import axios from "axios";
import MyFooter from "@/components/layout/MyFooter";
import Header from "@/components/layout/Header";
import FormQuestionner from "../Questionner/formQuestionner.vue";
export default {
  data() {
    return {
      meeting_name: "",
      meeting_id: "",
      loading: true,
      background: "",
      url_textit: process.env.URL_MEDIA,
      url_participant: this.$route.params.url_participant,
      window: {
        width: window.innerWidth
      },
      colidee: null
    };
  },
  components: {
    MyFooter,
    Header,
    FormQuestionner
  },
  updated() {
    let message = {
      task: "updateHeight",
      height:
        document.body.scrollHeight > 1080
          ? document.body.scrollHeight + 100
          : 1080
    };
    window.top.postMessage(message, "*");
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    window.addEventListener("load", function() {
      let message = {
        height: document.body.scrollHeight,
        width: document.body.scrollWidth
      };
      window.top.postMessage(message, "*");
    }),
      window.addEventListener("resize", this.handleResize);
    axios.defaults.headers.common["urlparticipant"] = JSON.stringify({
      urlParticipant: this.url_participant,
      authorizedPreview: this.$store.getters.authorizedPreview,
      colideeViewResultsClient: false
    });
    axios
      .get(process.env.URL_SSO_API + "textit/checkurlparticipant")
      .then(response => {
        if (
          response.data[0].id_entreprise !== null &&
          response.data[0].id_plateforme !== null
        ) {
          this.colidee = {
            enterprise: response.data[0].id_entreprise,
            plateforme: response.data[0].id_plateforme
          };
        }
        if (!this.$store.getters.authorizedPreview) {
          console.log(response.data[0], "response.data[0]");
          if (response.data[0].state) {
            if (
              (response.data[0].open_at !== "1970-01-01 00:00:00" &&
                response.data[0].open_at !== null) ||
              (response.data[0].close_at !== "1970-01-01 00:00:00" &&
                response.data[0].close_at !== null)
            ) {
              if (
                response.data[0].open_at !== "1970-01-01 00:00:00" &&
                response.data[0].open_at !== null &&
                new Date(response.data[0].open_at.replace(" ", "T")) >=
                  new Date()
              ) {
                this.$buefy.toast.open({
                  type: "is-danger",
                  message: this.$i18n.t("toast.reunion_invalide")
                });
                this.$router.push({ name: "home" });
              } else if (
                response.data[0].close_at !== "1970-01-01 00:00:00" &&
                response.data[0].close_at !== null &&
                new Date(response.data[0].close_at.replace(" ", "T")) <=
                  new Date()
              ) {
                this.$buefy.toast.open({
                  type: "is-danger",
                  message: this.$i18n.t("toast.reunion_invalide")
                });
                this.$router.push({ name: "home" });
              }
            }
          }
        }
        this.meeting_name = response.data[0].name;
        this.meeting_id = response.data[0].id;
        if (response.data[0].media) {
          this.background =
            "height:100%; background-size:cover;background-repeat:no-repeat;background-image:url('" +
            this.url_textit +
            response.data[0].media +
            "')";
        }
        this.loading = false;
      })
      .catch(error => {
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("toast.reunion_invalide")
        });

        this.$router.push({ name: "home" });
      });
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
    }
  }
};
</script>

<style scoped>
.cartouchePublic {
  background: white;
  text-align: left;
  height: 50px;
  padding: 5px;
  font-size: 1.5em;
  position: relative;
  color: white;
  background-color: #424a60;
}

.cartouchePublic a {
  color: #f8df40;
}
.cartouchePublic img {
  height: 45px;
  vertical-align: middle;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Questionner.vue